import * as React from 'react'
import Polygon from '../icons/ui/Polygon'

export interface ISelectProps {
  selectItems: string[]
  onSelect: (item: any) => any
}

class Select extends React.Component<ISelectProps, any> {
  constructor(props: ISelectProps) {
    super(props)
    this.state = {
      isOpen: false,
      selectedItem: this.props.selectItems[0]
    }
  }

  public handleToggle = () => this.setState({ isOpen: !this.state.isOpen })

  public handleSelect = (selectedItem: any) => () => {
    this.setState({
      isOpen: false,
      selectedItem
    })
    this.props.onSelect(selectedItem)
  }

  public render() {
    if (!this.props.selectItems || !this.props.selectItems.length) {
      return null
    }
    return (
      <div className='membership-request-select bg-white'>
        <div className='flex' onClick={this.handleToggle}>
          <div>{this.state.selectedItem}</div>
          <Polygon className='icon--10x10 polygon' />
        </div>
        {this.state.isOpen && (
          <div className='absolute select-items bg-white border-grey4 rounded select--items'>
            {this.props.selectItems.map((item: string, key: number) => (
              <div key={key} className='select-item' onClick={this.handleSelect(item)}>
                {item}
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/components/membership-request/Select.tsx